import axios from "./axios";

export async function getProfile() {
  try {
    const resp = await axios.get(`/users/me`);
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function getUsers(query: any) {
  try {
    const resp = await axios.get(`/users`, {
      params: query,
    });
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function getUserDetails(user_id: string) {
  try {
    const resp = await axios.get(`/users/${user_id}`);

    return resp.data;
  } catch (err) {
    console.error(err);
  }
}

export async function updateUser(user_id: string, data: any) {
  try {
    const resp = await axios.put(`/users/${user_id}`, data);

    return resp.data;
  } catch (err) {
    console.error(err);
  }
}

export async function inviteUser(data: any) {
  try {
    const resp = await axios.post(`/users`, data);

    return resp.data;
  } catch (err: any) {
    console.error(err);
    throw err;
  }
}

export async function reinviteUser(user_id: any) {
  try {
    const resp = await axios.post(`/users/${user_id}/invitations/resend`);
    return resp.data;
  } catch (err: any) {
    console.error(err);
    throw err;
  }
}

export async function updateUserPreferences(data: any) {
  try {
    const resp = await axios.post(`/users/preferences`, data);

    return resp.data;
  } catch (err) {
    console.error(err);
  }
}

export async function getUserPreferences(user_id: string) {
  try {
    const resp = await axios.get(`/users/${user_id}/preferences`);

    return resp.data;
  } catch (err) {
    console.error(err);
  }
}
